import React, { useState } from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";

import { ReactComponent as FooterLogo } from "../../assets/svg/Footer-logo.svg";
// import { ReactComponent as EmailArr } from "../../assets/svg/email-arrow.svg";
import { ReactComponent as ArrUp } from "../../assets/svg/arrow-up.svg";
// import { ReactComponent as Facebook } from "../../assets/svg/Facebook.svg";
// import { ReactComponent as Twitter } from "../../assets/svg/Twitter.svg";
import { ReactComponent as Instagram } from "../../assets/svg/Instagram.svg";
import { ReactComponent as LinkedIn } from "../../assets/svg/LinkedIn.svg";

const Footer = () => {
  const [email, setEmail] = useState("");

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToSection = (id) => {
    if (window.location.pathname === "/") {
      const section = document.getElementById(id);
      const offsetTop = section.offsetTop;

      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  const handleSubscribe = () => {
    if (email.trim()) {
      alert(`Thank you for subscribing! We'll send updates to ${email}`);
      setEmail("");
    } else {
      alert("Please enter a valid email address.");
    }
  };

  return (
    <footer className="footer">
      <section className="footer__container container">
        <div className="footer__container-logo">
          <FooterLogo />
        </div>

        <div className="divider"></div>

        <div className="footer__container--wrapper">
          <div className="footer__container--wrapper--quickLinks">
            <div className="quickLinks--link">
              <h3 className="quickLinks--link-title">Company</h3>

              <ul className="quickLinks--link-list">
                <li className="footer__container--link-list-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="footer__container--link-list-item">
                  <p
                    onClick={() => {
                      scrollToSection("recent-works");
                    }}
                  >
                    Work
                  </p>
                </li>
                <li className="footer__container--link-list-item">
                  <Link to="/about-us">About Us </Link>
                </li>
                <li className="footer__container--link-list-item">
                  <Link to="/our-process">Our Methods</Link>
                </li>
              </ul>
            </div>

            <div className="quickLinks--link">
              <h3 className="quickLinks--link-title">Discover</h3>

              <ul className="quickLinks--link-list">
                <li className="footer__container--link-list-item">
                  <Link to="/case-studies">Case Studies</Link>
                </li>
                <li className="footer__container--links-list-item">
                  <Link to="/blogs">Blogs</Link>
                </li>
                <li className="footer__container--links-list-item">
                  <p
                    onClick={() => {
                      scrollToSection("FAQ");
                    }}
                  >
                    FAQ
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer__container--wrapper--newsletter">
            <p className="footer-info">
              Get valuable strategy, culture, and brand insights straight to
              your inbox.
            </p>

            <div className="footer--input-wrapper">
              <div className="footer--input-group">
                <input 
                  className="footer-input" 
                  type="email" 
                  placeholder="Enter your email address" 
                  aria-label="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSubscribe()}
                />
                <button 
                  className="footer-button" 
                  type="button"
                  onClick={handleSubscribe}
                >
                  Subscribe
                </button>
              </div>
              <p className="footer-terms">
                By signing up to receive emails from Radiksez, you agree to our
                <Link to="/"> Privacy Policy.</Link> We treat your info
                responsibly. Unsubscribe anytime.
              </p>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        <div className="footer__container--social">
          {/* <Link to="/">
            <Facebook />
          </Link> */}

          <Link to="https://www.linkedin.com/company/radiksez/" target="_blank">
            <LinkedIn />
          </Link>

          <Link to="https://www.instagram.com/radiksez/" target="_blank">
            <Instagram />
          </Link>

          {/* <Link to="/">
            <Twitter />
          </Link> */}
        </div>

        <div className="footer__bottom">
          <small className="footer__bottom-text">
            Copyright © {new Date().getFullYear()} Radiksez®
          </small>

          <button
            type="button"
            to="#"
            className="footer__scroll-up-btn flex"
            onClick={scrollToTop}
          >
            <span>Back to top</span>
            <ArrUp />
          </button>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
